import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useStoreCatalogs, StoreCatalog } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<StoreCatalog> useData={useStoreCatalogs} config={config} />;
};

export default List;
